const FilterProperties = {
  'NAME': {
    APP_NAME: 'name',
    DDB_NAME: 'name'
  },
  'PHONE_NO': {
    APP_NAME: 'phoneNo',
    DDB_NAME: 'phoneNo'
  },
  'EMAIL': {
    APP_NAME: 'email',
    DDB_NAME: 'email'
  },
  'LEAD_STAGE': {
    APP_NAME: 'leadStage',
    DDB_NAME: 'leadStage'
  },
  'ASSIGNED_TO': {
    APP_NAME: 'assignedTo',
    DDB_NAME: 'assignedTo'
  },
  'DATE_ADDED_START': {
    APP_NAME: 'dateAddedStart',
    DDB_NAME: 'dateAddedStart'
  },
  'TARGET_BATCH': {
    APP_NAME: 'targetBatch',
    DDB_NAME: 'targetBatch'
  },
  PropertiesList: ['NAME', 'PHONE_NO', 'EMAIL', 'LEAD_STAGE', 'ASSIGNED_TO', 'DATE_ADDED_START', 'TARGET_BATCH']
}


export { FilterProperties };
